import { useCallback, useMemo } from "react";
import shallow from "zustand/shallow";
import { Color as ColorType } from "../store/types/store";
import { Color } from "three";
import { useShelvingStore } from "../store/useShelvingStore";

export const colorsNames: Record<ColorType, string> = {
    red: "КРАСНЫЙ гладкий глянец - RAL3020",
    white: "Оцинкованная сталь - без окрашивания",
    silver: "СЕРЫЙ металлик тёмный - RAL9023 гладкий глянец",
    black: "ЧЁРНЫЙ муар матовый - RAL9005",
    orange: "ОРАНЖЕВЫЙ гладкий глянец RAL2008",
    yellow: "ЖЁЛТЫЙ гладкий глянец RAL1018",
    blue: "СИНИЙ гладкий глянец RAL5005",
    totalWhite: "БЕЛЫЙ",
};

export const useColors = () => {
    const { colorsItems, setColorsItems } = useShelvingStore(
        (state) => ({ colorsItems: state.colorsItems, setColorsItems: state.setColorsItems }),
        shallow
    );

    const colorsShade = {
        red: new Color(0xbb1e10),
        white: new Color(undefined),
        totalWhite: new Color(undefined),
        silver: new Color(0x797b7a),
        black: new Color(0x0e0e10),
        orange: new Color(0xf7941d),
        yellow: new Color(0xffff00),
        blue: new Color(0x0072bc),
    };

    const normalizedColorsItems = useMemo(
        () => ({
            guides: colorsItems?.guides ?? "white",
            shelves: colorsItems?.shelves ?? "white",
            perfpanels: colorsItems?.perfpanels ?? "white",
            brackets: colorsItems?.brackets ?? "red",
            tireRacks: colorsItems?.tireRacks ?? colorsItems?.brackets ?? "red",
            workbenchToolbox: colorsItems?.workbenchToolbox ?? "orange",
        }),
        [colorsItems]
    );

    const setGuidesColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, guides: color }),
        [normalizedColorsItems, setColorsItems]
    );
    const setShelvesColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, shelves: color }),
        [normalizedColorsItems, setColorsItems]
    );
    const setPerfPanelsColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, perfpanels: color }),
        [normalizedColorsItems, setColorsItems]
    );
    const setBracketsColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, brackets: color }),
        [normalizedColorsItems, setColorsItems]
    );
    const setTireRacksColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, tireRacks: color }),
        [normalizedColorsItems, setColorsItems]
    );
    const setWorkbenchToolboxColor = useCallback(
        (color: ColorType) => setColorsItems({ ...normalizedColorsItems, workbenchToolbox: color }),
        [normalizedColorsItems, setColorsItems]
    );

    return {
        colorsItems: normalizedColorsItems,
        colorsShade,
        setColorsItems,
        setGuidesColor,
        setShelvesColor,
        setPerfPanelsColor,
        setBracketsColor,
        setTireRacksColor,
        setWorkbenchToolboxColor,
    };
};
